/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CurvePoint } from './CurvePoint';
import type { EnumOption } from './EnumOption';

/**
 * Parameter declaration on a custom node definition.
 *
 * Mirrors the param shape used by built-in nodes in the registry.
 */
export type ParamDef = {
    name: string;
    type: ParamDef.type;
    default: (number | string | Array<number> | Array<CurvePoint>);
    options?: (Record<string, number> | Array<EnumOption> | null);
    visible_when?: (Record<string, (string | Array<string>)> | null);
    visible_when_input?: (Record<string, 'connected' | 'disconnected'> | null);
    label?: (string | null);
    group?: (string | null);
    min?: (number | null);
    max?: (number | null);
    step?: (number | null);
    tooltip?: (string | null);
    at_most_param?: (string | null);
};

export namespace ParamDef {

    export enum type {
        INT = 'int',
        FLOAT = 'float',
        VEC2 = 'vec2',
        VEC3 = 'vec3',
        COLOR = 'color',
        ENUM = 'enum',
        CURVE = 'curve',
    }


}

